import FlexContainer from '@powerednow/components/FlexContainer/FlexContainer';
import React, { useState } from 'react';
import { DocumentEntityWithAlreadyInvoicedAmount } from '@powerednow/models/document/hooks';
import Box from '@powerednow/components/Box/Box';
import ColoredButton from '@powerednow/components/button/ColoredButton';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import QuoteCard from './QuoteCard';

interface QuoteListProps {
    documents: DocumentEntityWithAlreadyInvoicedAmount[],
    onCardClick: (document: DocumentEntityWithAlreadyInvoicedAmount) => void
    hasNotFullyPaidDocuments: boolean,
}

const useStyles = makeStyles<Theme>(createStyles({
    displayQuoteListToggleButton: {
        verticalAlign: 'initial',
    },
}));

function QuoteList({ documents, onCardClick, hasNotFullyPaidDocuments }: QuoteListProps) {
    const classes = useStyles();

    const [showDocuments, setShowDocuments] = useState(hasNotFullyPaidDocuments);
    return (
        <FlexContainer mt={4}>
            {showDocuments ? documents.map(document => (
                <QuoteCard
                    key={`quote-card-${document.id}`}
                    quote={document}
                    onClick={() => onCardClick(document)}
                />
            )) : (
                <Box>
                    You are out of not fully invoiced quotes!
                    Click to the Show more button to see the full quote list:
                    <ColoredButton
                        className={classes.displayQuoteListToggleButton}
                        onClick={() => setShowDocuments(true)}
                        color="secondary"
                    >
                        Show more
                    </ColoredButton>
                </Box>
            )}
        </FlexContainer>
    );
}

export default QuoteList;
